// Re-export limitation functions from zod-schema
export {
  planLimits,
  isUserLimitExceeded,
  isInvoiceLimitExceeded,
  isBillLimitExceeded,
  isRelationLimitExceeded,
  isOrganizationLimitExceeded,
  getPlanUserLimit,
  isDecreasedPlan,
  // Backwards compatibility alias
  isDecreasedPlan as isDecreedPlan,
} from "@billingnow/zod-schema";

// Legacy constants for backwards compatibility
export const liteUserLimitation = 1;
export const plusUserLimitation = 1;
export const premiumUserLimitation = 2;
export const EnterpriseUserLimitation = 4;
export const liteInvoiceLimitation = 5;
export const plusInvoiceLimitation = 100;
export const premiumInvoiceLimitation = 1000;
export const enterpriseInvoiceLimitation = Infinity;
export const liteBillLimitation = 5;
export const plusBillLimitation = 10;
export const premiumBillLimitation = 50;
export const enterpriseBillLimitation = Infinity;
export const liteRelationLimitation = 3;
export const plusRelationLimitation = 25;
export const premiumRelationLimitation = 100;
export const enterpriseRelationLimitation = Infinity;
export const liteOrganizationLimitation = 1;
export const plusOrganizationLimitation = 1;
export const premiumOrganizationLimitation = 1;
export const enterpriseOrganizationLimitation = Infinity;
